var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78808 19.7588C6.81593 19.4921 9.0997 19.9582 11.1478 21.0765C12.0043 21.542 12.6358 21.3622 12.6358 20.5117C12.6179 17.4934 12.6126 12.9336 12.6227 9.90465C12.6227 9.05471 11.968 7.85657 11.1234 7.39053C9.0997 6.27037 6.97365 5.8079 4.93331 6.07276C4.0798 6.18109 3.32211 7.10424 3.24295 7.9524C2.94535 10.9748 2.91976 15.5364 3.17391 18.5618C3.23938 19.4147 3.94171 19.8671 4.78808 19.7588Z",
    fill: "url(#paint0_linear_4003_462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0192 7.9524C22.9406 7.10424 22.1823 6.18109 21.3294 6.07276C19.2867 5.8079 17.163 6.27037 15.1394 7.39053C14.2942 7.85657 13.6395 9.05709 13.6406 9.90465C13.6502 12.9336 13.6454 17.4934 13.627 20.5117C13.627 21.3622 14.2573 21.542 15.1149 21.0765C17.1624 19.9582 19.4462 19.4921 21.4746 19.7588C22.3216 19.8671 23.0222 19.4147 23.0924 18.5618C23.3454 15.5364 23.3162 10.9748 23.0192 7.9524Z",
    fill: "url(#paint1_linear_4003_462)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4003_462",
    x1: 13.7893,
    y1: 19.7909,
    x2: 2.26028,
    y2: 8.26131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4003_462",
    x1: 23.162,
    y1: 18.9541,
    x2: 13.3067,
    y2: 9.09875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a4685868960b9631e04979bc5c8d0094.svg";
export { ForwardRef as ReactComponent };